import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { LiveStatus, LiveStatusConvoyDetail, LiveStatusDetail } from '../types/liveStatus';
import { getRequest } from './api';
import { liveStatusUrl } from './urls/liveStatusUrls';

export const getLiveStatus = async (
  clientId: string,
  subClientId: string
): Promise<{ liveStatus?: LiveStatus[]; error?: ApiError }> => {
  const response = await getRequest(liveStatusUrl, { queryParams: { clientId, subClientId } });
  return {
    liveStatus: response?.data,
    error: response?.error,
  };
};

export const getLiveStatusDetail = async (
  clientId: string,
  subClientId: string,
  page: number,
  url: string,
  download: boolean
): Promise<{
  paginatedResponse?: PaginatedResponse<LiveStatusConvoyDetail | LiveStatusDetail>;
  error?: ApiError;
}> => {
  const response = await getRequest(url, { queryParams: { clientId, subClientId, download, page } });

  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const downloadLiveStatusDetail = async (
  clientId: string,
  subClientId: string,
  url: string
): Promise<{
  csv?: string;
  error?: ApiError;
}> => {
  const response = await getRequest(url, { queryParams: { clientId, subClientId, download: true } });

  return {
    csv: response?.data,
    error: response?.error,
  };
};
